/** Max length of bookings.agent_reference — mirrors the bookings_agent_reference_len CHECK (0357). */
export const AGENT_REFERENCE_MAX = 64;

/**
 * Normalise the optional agent booking reference from a request body: trimmed, inner whitespace
 * collapsed; missing / blank → null. Over-length is an error rather than a silent truncation — a
 * cut-off reference would never match the agent's own records, which is the whole point of it.
 */
export function parseAgentReference(raw: unknown): { value: string | null } | { error: string } {
  if (raw == null) return { value: null };
  if (typeof raw !== "string") return { error: "The agent booking reference must be text." };
  const value = raw.trim().replace(/\s+/g, " ");
  if (value === "") return { value: null };
  if (value.length > AGENT_REFERENCE_MAX) {
    return { error: `The agent booking reference can be at most ${AGENT_REFERENCE_MAX} characters.` };
  }
  return { value };
}
